<template>
    <f-dialog
        v-if="show"
        v-model       = "show"
        :width        = "450"
        :show-header  = "false"
        :hide-actions = "false"
        :inset        = "false"
        content-class = "dialog-border"
        :store-label  = "$t('dms.move.label')"
        :show-save    = "enableMove"
        @store        = "onMove"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div class="pa-4">
                <div style="font-size: 16px; font-weight: 700" class="primary--text mb-1 pl-1">
                    Dokument ...
                </div>
                <div class="lm-border pa-0" >
                    <p-dms-entry-card
                        :document = "document"
                    />
                </div>
                <div class="move-to-label primary--text">
                    {{ $t('dms.move.to') }}
                </div>
                <div class="lm-border pa-2">
                    <div class="v-flex">
                        <v-text-field
                            label   = "Ereignis"
                            v-model = "target.incident.id"
                            style   = "width: 90px"
                            type           = "Number"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            @input  = "onIncident"
                        />
                        <div class="pl-2" style="padding-top: 18px; width: calc(100% - 90px)">
                            <f-read-only-field
                                :value="target.incident.type"
                                filled
                            />
                        </div>
                    </div>

                    <v-select
                        class="mb-2"
                        label          = "Bearbeitungsschritt"
                        v-model        = "target.step"
                        :items         = "targets"
                        item-value     = "id"
                        item-text      = "name"
                        :return-object = true
                        :disabled      = "!enableMove"
                    />
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import Inc            from "@/modules/inc/service/Inc";
import Dms            from "@/modules/dms/common/service/Dms";
import FDialog        from "@/modules/core/components/utils/FDialog.vue";
import PDmsEntryCard  from "@/modules/dms/menu/components/private/PDmsEntryCard.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "PDmsMove",
    components: {
        FReadOnlyField,
        PDmsEntryCard,
         FDialog,
    },

    props: {
        stepDataId: {

        },

        document: {

        },

        value: {

        }
    },

    data: () => ({
        enableMove: false,
        show   : false,
        targets: [],
        target : {
            incident: {
                id: null,
                type: null,
            },
            step: null
        },
    }),

    computed: {
        incident () {
            return this.$store.getters.incident;
        },
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.load();
            }
        }
    },

    mounted() {
        this.show = this.value;
        if (this.show) {
            this.load();
        }
    },

    methods: {
        onMove () {
            if (!this.target.step || !this.target.step.stepDataId) {
                Core.message.error(this, "Bitte ein Ziel auswählen");
                return;
            }

            Inc.document.move(this, this.document.id, this.target.step.stepDataId, this.target.step.bidId).then((data) => {
                if (this.incident.id === this.target.incident.id) {
                    this.$bus.$emit(Dms.event.document.refresh, {
                        id       : this.target.step.stepDataId,
                        documents: data.target
                    });
                }

                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data.source
                });

                Core.message.hint(this,  this.$t("dms.entry.message.move"));
                this.$emit("input", false);
            })
        },

        onIncident () {
            Inc.search.byId(this.target.incident.id).then (data => {
                if (data) {
                    this.target.incident.type = data.type;
                    this.loadIncident(this.target.incident.id);
                } else {
                    this.target.incident.type = "---";
                    this.enableMove = false;
                }
            });
        },

        onCancel () {
            this.$emit("input", false);
        },

        load () {
            this.loadIncident(this.incident.id);
        },

        loadIncident (incidentId) {
            Inc.get(incidentId).then(incident => {
                this.target.incident.id = incident.id;
                this.target.incident.type = incident.typeName;

                this.targets = [];
                this.targets.push ({
                    id        : 0,
                    stepDataId: null,
                    name      : "Bitte auswählen",
                    bidId     : null,
                });

                this.target.step = this.targets[0];
                incident.data.forEach(data => {
                    if (data.visible) {
                        if (data.id !== this.stepDataId) {
                            this.targets.push ({
                                id        : data.id,
                                stepDataId: data.id,
                                name      : data.stepName,
                                bidId     : null,
                            });
                        }

                        if (data.bids) {
                            data.bids.forEach (bid => {
                                if (bid.active) {
                                    this.targets.push ({
                                        id   : data.id + "-" + bid.id,
                                        stepDataId: data.id,
                                        name : this.$t("repair.bid.name." + bid.bidname),
                                        bidId: bid.id,
                                    });
                                }
                            });
                        }
                    }
                });
                this.enableMove = true;
            });
       },
    }
}
</script>

<style scoped>

.move-to-label {
    font-size: 16px;
    font-weight: 700;
    padding-top: 16px;
    padding-bottom: 4px;
    margin-left: 4px;
}

</style>